import urlApi from "./urlApi";
export var GET_THEMATIC_CONTENT_REQUEST = 'GET_THEMATIC_CONTENT_REQUEST';
export var GET_THEMATIC_CONTENT_REQUEST_SUCCESS = 'GET_THEMATIC_CONTENT_REQUEST_SUCCESS';
export var GET_THEMATIC_CONTENT_REQUEST_ERROR = 'GET_THEMATIC_CONTENT_REQUEST_ERROR';
export function getThematicContent(params) {
    return function (dispatch) {
        dispatch({
            type: GET_THEMATIC_CONTENT_REQUEST,
        });
        // return urlApi().GetThematicContent(params).then(res => {
        return urlApi().GetReadMoreLongreads(params).then(function (res) {
            dispatch({
                type: GET_THEMATIC_CONTENT_REQUEST_SUCCESS,
                payload: res,
            });
        }).catch(function (err) {
            dispatch({
                type: GET_THEMATIC_CONTENT_REQUEST_ERROR,
                payload: err,
            });
        });
    };
}
//# sourceMappingURL=getThematicContent.js.mapimport urlApi from "./urlApi";
export var GET_THEMATIC_CONTENT_REQUEST = 'GET_THEMATIC_CONTENT_REQUEST';
export var GET_THEMATIC_CONTENT_REQUEST_SUCCESS = 'GET_THEMATIC_CONTENT_REQUEST_SUCCESS';
export var GET_THEMATIC_CONTENT_REQUEST_ERROR = 'GET_THEMATIC_CONTENT_REQUEST_ERROR';
export function getThematicContent(params) {
    return function (dispatch) {
        dispatch({
            type: GET_THEMATIC_CONTENT_REQUEST,
        });
        // return urlApi().GetThematicContent(params).then(res => {
        return urlApi().GetReadMoreLongreads(params).then(function (res) {
            dispatch({
                type: GET_THEMATIC_CONTENT_REQUEST_SUCCESS,
                payload: res,
            });
        }).catch(function (err) {
            dispatch({
                type: GET_THEMATIC_CONTENT_REQUEST_ERROR,
                payload: err,
            });
        });
    };
}
//# sourceMappingURL=getThematicContent.js.map